import { render, staticRenderFns } from "./LinksList.vue?vue&type=template&id=8ca35cb0&scoped=true&"
import script from "./LinksList.vue?vue&type=script&lang=js&"
export * from "./LinksList.vue?vue&type=script&lang=js&"
import style0 from "./LinksList.vue?vue&type=style&index=0&id=8ca35cb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca35cb0",
  null
  
)

export default component.exports